import { Value } from '@udecode/plate-common';
import { z } from 'zod';
import { Address } from '../api/commonTypes';
import { PoDelivery, PoStatus } from './usePurchaseOrderService';

export interface SelectedFinanceModel {
  financeCategoryId: string;
  modelId: string;
}

export interface SelectedProduct {
  productId: string;
  quantity: number;
}

export interface PurchaseOrder {
  id?: string;
  name?: string;
  selectedProducts: SelectedProduct[];
  selectedFinanceModels: SelectedFinanceModel[];
  delivery?: PoDelivery;
  status: PoStatus;
  poRef?: string;
  stockingOrder?: string;
  partnerRef?: string;
  notes?: {
    value: Value;
  };
}

export const buildBlankOrder = () => {
  const newOrder: PurchaseOrder = {
    selectedProducts: [],
    selectedFinanceModels: [],
    status: PoStatus.Draft
  };

  return newOrder;
};

export const PODeliveryAddress = Address.merge(
  z.object({
    name: z.string().min(1, 'Required')
  })
);

export type PODeliveryAddress = z.infer<typeof PODeliveryAddress>;
